import { Component, OnInit, Inject } from '@angular/core';
import { ExcepcionesComponent } from '../excepciones/excepciones.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';

/**
 * Obtenemos el Mensaje a mostrar
 */
export interface SendData {
  message: string;
}

@Component({
  selector: 'app-confirm-dialog-ok',
  templateUrl: './confirm-dialog-ok.component.html',
  styleUrls: ['./confirm-dialog-ok.component.sass']
})
export class ConfirmDialogOkComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ConfirmDialogOkComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendData
  ) {
  }

  ngOnInit() {
  }

  cancelar(): void {
    try {
      this.dialogRef.close();
    } catch (error) {
      this.excepciones(error, 1);
    }
  }

  excepciones(stack, tipoExcepcion: number) {
    try {
      const dialogRef = this.dialog.open(ExcepcionesComponent, {
        width: '60%',
        data: {
          idTipoExcepcion: tipoExcepcion,
          idOperacion: 1,
          idAplicacion: environment.aplicacionesId,
          moduloExcepcion: 'app-confirm-dialog',
          mensajeExcepcion: '',
          stack
        }
      });

      dialogRef.afterClosed().subscribe((result: any) => {
      });
    } catch (error) {
      console.error(error);
    }
  }

}
